
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { ChartOrientation, isStackedTreeLayout, isTreeLayout, LevelLayout, UnitLevelDistance } from "orbatchart";
import { PanelMixins, SettingsPanelMixins } from "@/components/mixins";
import { getEnumMap } from "@/utils";
import SettingsUnit from "@/components/SettingsUnit.vue";
import SettingsLevel from "@/components/SettingsLevel.vue";
import SettingsLevelGroup from "@/components/SettingsLevelGroup.vue";


@Component({
  components: { SettingsLevelGroup, SettingsLevel, SettingsUnit }
})
export default class SettingsPanel extends mixins(PanelMixins, SettingsPanelMixins) {
  get orientation() {
    return getEnumMap(ChartOrientation);
  }

  get unitLevelDistance() {
    return getEnumMap(UnitLevelDistance);
  }

  get lastLevelLayout() {
    return getEnumMap(LevelLayout);
  }

  get noTreeOffset() {
    return !isTreeLayout(this.settings.lastLevelLayout);
  }

  get noStackedTreeOffset() {
    return !isStackedTreeLayout(this.settings.lastLevelLayout);
  }

  updateNum(prop, value) {
    this.$store.commit("updateChartOptions", { [prop]: +value });
  }

  updateVal(prop, value) {
    this.$store.commit("updateChartOptions", { [prop]: value });
  }
};

